import request from '../request'

// 添加可信设备
export const addCredibleEquipment = (payload, header = {}) => {
  return request({
    url: `/v3/auth/trusted_devices`,
    method: 'POST',
    data: payload,
    header,
  })
}

// 获取设备列表
export const getCredibleEquipment = (payload, header = {}) => {
  return request({
    url: `/v3/auth/trusted_devices`,
    method: 'GET',
    params: payload,
    header
  })
}

// 删除设备
export const delCredibleEquipment = (payload, header = {}) => {
  return request({
    url: `/v3/auth/trusted_devices/${payload}`,
    method: 'DELETE',
    header,
  })
}

// 批量删除可信设备
export const batchDelCredibleEquipment = (payload, header = {}) => {
  return request({
    url: `/v3/auth/trusted_devices`,
    method: 'DELETE',
    data: payload,
    header
  })
}